import { render } from "./RelevancyDialog.vue?vue&type=template&id=5ac99d46&scoped=true"
import script from "./RelevancyDialog.vue?vue&type=script&lang=js"
export * from "./RelevancyDialog.vue?vue&type=script&lang=js"

import "./RelevancyDialog.vue?vue&type=style&index=0&id=5ac99d46&lang=less&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac99d46"]])

export default __exports__